<script setup lang="ts">
type ProductCardImageProps = {
  image: {
    url: string
    alt: string
  }
  productUrl: string | undefined
}

const props = defineProps<ProductCardImageProps>()

const img = computed(() => {
  const size1x = 300
  const size2x = 600
  const url = props.image?.url || '/images/product-unavailable.jpg'
  const src = `${url}?sw=${size1x}&sm=fit&q=90`
  const srcset = `${url}?sw=${size1x}&sm=fit&q=90 1x, ${url}?sw=${size2x}&sm=fit&q=90 2x`

  return { src, srcset }
})
</script>

<template>
  <div>
    <Anchor v-if="productUrl" :href="productUrl">
      <img
        :srcset="img.srcset"
        :src="img.src"
        :alt="image?.url ? image?.alt : $t('product.images.unavailable_alt_text')"
        :class="{ 'product-image-unavailable': !image?.url }"
      />
    </Anchor>
    <img
      v-else
      :srcset="img.srcset"
      :src="img.src"
      :alt="image?.url ? image?.alt : $t('product.images.unavailable_alt_text')"
      :class="{ 'product-image-unavailable': !image?.url }"
    />
  </div>
</template>

<style lang="postcss"></style>
